module.exports = __webpack_public_path__ + "static/img/medical.c8e782a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/medical.jpg
// module id = vNDC
// module chunks = 18